export const US = [
  {
    id: 1,
    name: 'Skip',
    username: 'Skipross55',
  },
  {
    id: 3,
    name: 'Joe',
    username: 'JoeHengst',
  },
  {
    id: 8,
    name: 'Louis',
    username: 'louques1',
  },
  {
    id: 7,
    name: 'Frank',
    username: 'frankkertis',
  },
  {
    id: 9,
    name: 'Jack',
    username: 'mag44laf',
  },
  {
    id: 6,
    name: 'Andy',
    username: 'andyrefman',
  },
  {
    id: 5,
    name: 'Robert',
    username: 'robtiff2011',
  },
  {
    id: 2,
    name: 'Quinn',
    username: 'broncodriver16',
  },
];

export const CA = [
  {
    name: 'hannah',
    stars: 5,
  },
  {
    name: 'Baxterodiehoosier',
    stars: 5,
  },
  {
    name: 'KJ_Miller',
    stars: 5,
  },
  {
    name: 'gassluver',
    stars: 5,
  },
  {
    name: 'Taimen',
    stars: 5,
  },
  {
    name: 'crownqltesq',
    stars: 5,
  },
  {
    name: 'mississippiamy',
    stars: 5,
  },
  {
    name: 'high mikes',
    stars: 5,
  },
  {
    name: 'heroqltetmo',
    stars: 5,
  },
];
